import React, { useContext } from 'react';
import { styled } from '@compiled/react';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { withTransparentErrorBoundary } from '@confluence/error-boundary/entry-points/withErrorBoundary.ts';
import { LoadableAfterPaint } from '@confluence/loadable';
import { ConfluenceEdition } from '@confluence/session-data/entry-points/SiteInformationQuery.ts';
import { SPAViewContext } from '@confluence/spa-view-context/entry-points/SPAViewContext.ts';
import { fg } from '@confluence/feature-gating';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Container = styled.div({
	display: 'none',
	'@media (min-width: 680px)': {
		display: 'initial',
	},
});

const EditionAwarenessUpsellLoadable = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-EditionAwarenessUpsell" */ './EditionAwarenessUpsell.tsx'
			)
		).EditionAwarenessUpsell,
});

type EditionAwarenessUpsellExperimentProps = {
	navVersion: 'nav3' | 'nav4';
};

export const EditionAwarenessUpsellExperiment: React.FC<EditionAwarenessUpsellExperimentProps> =
	withTransparentErrorBoundary({
		attribution: Attribution.GROWTH_LUNA,
	})(({ navVersion }: EditionAwarenessUpsellExperimentProps) => {
		const { isSiteAdmin } = useContext(SPAViewContext);
		const { edition } = useSessionData();

		if (
			edition === ConfluenceEdition.STANDARD &&
			isSiteAdmin &&
			fg('standard-to-premium-ea-refactor')
		) {
			return null;
		}

		return (
			<Container>
				<EditionAwarenessUpsellLoadable navVersion={navVersion} />
			</Container>
		);
	});
